<script>
import { defineComponent } from 'vue';
import vueNumberInput from '@chenfengyuan/vue-number-input';
import Incrementer from '@/helpers/increment.js';
import Favorite from '@/components/global/Favorites.vue';

export default defineComponent({
    name: 'pricesheetItem',
    props: {
        item: Object,
    },
    data() {
        return {
            qty: this.defaultIncrement
        }
    },
    setup() {},
    components: {
        vueNumberInput,
        Favorite
    },
    methods: {
        onBeforeShow(evt) {
            console.log(evt);
        },
        onHide(evt) {
            console.log(evt)
        },
        onHandQty(num) {
            return new Intl.NumberFormat('en-EN', { minimumFractionDigits: 0, maximumFractionDigits:0 }).format(num)
        },
        addToCart() {
            this.$store.dispatch('cart/addToCart', [this.accessToken, this.item.itemNumber, this.qty])
        },
        price() {
            return new Intl.NumberFormat('en-EN', { minimumFractionDigits: 2, maximumFractionDigits:2 }).format(this.item.price)
        },
    },
    computed: {
        defaultIncrement() {
            return Incrementer.DefaultCutLength(this.item.itemNumber, this.item.priceUnitOfMeasure)
        },
        accessToken() {
            return this.$store.getters['auth/accessToken'];
        }
    }

})
</script>

<template>

    <q-item :key="idx" class="q-pa-none" :dense=true>
        <q-item-section>
            <div class="row q-pb-md">
                <div class="col-8">
                    <div class="row">
                        <div class="col-1 q-mt-sm q-mr-sm">
                            <favorite :item="item.itemNumber" :accessToken="accessToken"></favorite>
                        </div>
                        <div class="col q-ml-sm q-mt-sm text-left">
                            <h3 style="line-height: 1.5em;">{{item.itemNumber}}</h3>
                            <p class="productDescription">{{item.description}}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-8 q-pr-md float-right">
                            <vue-number-input v-model.number="qty" :model-value="defaultIncrement" min="0" :step="defaultIncrement" :inputtable="false"  size="small" @input="onInput" controls center></vue-number-input>
                        </div>
                        <div class="col-3 q-pl-xl q-ml-md text-right float-right">
                            <q-btn color="cyan-7" size="md" :unelevated=true :ripple=true padding="3px 12px 3px 12px" icon="fas fa-cart-plus" class="float-right" style="margin-right: 40px;" :disabled="qty < 1" @click="addToCart()"/>
                        </div>
                    </div>
                </div>
                <div class="col-4">
                    <div class="q-mr-sm text-right">
                        <button type="button" class="btn btn-consignment btn-onHand btn-sm q-mt-sm" style="height: 38px !important;width: 130px;"><span>Inventory</span><span class="text-dark">{{onHandQty(item.onHandQuantity)}}</span></button>
                    </div>
                    <div class="q-pt-xs text-right q-mr-sm">
                        <q-btn size="sm" class="q-pa-sm q-mt-sm" color="warning" label="Request Price" icon="fas fa-dollar-sign" v-if="item.price==0" style="height: 29px !important;width: 130px;"/>
                        <q-btn unelevated v-if="item.price>0" class="q-mt-sm" color="positive" :label="`${item.price} ${item.priceUnitOfMeasure}`" icon="fas fa-dollar-sign" style="height: 24px !important;width: 130px;"/>
                    </div>
                </div>  
            </div>
        </q-item-section>
    </q-item>

</template>

<style>
.expandIconWCW i{font-size: 45px !important; padding-right: 0px;}
.productDescription{height: 32px;}
</style>